import {
  GET_ORDER_SUCCESS,
  ORDER_REQUESTING,
  LIST_ORDERS_SUCCESS,
  RESET_ORDER_QUERY,
  RESET_ORDER_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: null,
  recordCount: null,
  isFetching: false,
  currentOrderId: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_ORDER_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESET_ORDER_QUERY: {
      return {
        ...state,
        query: null,
        recordCount: null
      };
    }
    case ORDER_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_ORDERS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.orders.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        data,
        query,
        isFetching: false,
        currentOrderId: null,
        recordCount: action.payload.total
      };
    }
    case GET_ORDER_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        query: null,
        isFetching: false,
        currentOrderId: action.payload.id,
        recordCount: null
      };
    }
    default:
      return state;
  }
};

export default reducer;
